import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { tentativeCost } from "./tentative";

const TentativeCostForm = ({ onCancel }) => {
  const { getTentativeCost, addOrUpdateTentativeCost } = tentativeCost();
  const [formData, setFormData] = useState({
    basement_grey_structure_budget_sq_ft: "",
    grey_structure_budget_house_other_sq_ft: "",
    basement_grey_structure_good_sq_ft: "",
    grey_structure_good_house_other_sq_ft: "",
    budget_finishes_sq_ft: "",
    a_quality_finishes_sq_ft: "",
    premium_quality_finishes_sq_ft: "",
  });

  useEffect(() => {
    getTentativeCost(setFormData);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addOrUpdateTentativeCost(formData);
    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Data has been successfully added!",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "OK",
    });
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
      <div className="grid grid-cols-2 gap-4">
        <label>
          Basement Grey Budget
          <input
            type="number"
            name="basement_grey_structure_budget_sq_ft"
            value={formData?.basement_grey_structure_budget_sq_ft}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </label>
        <label>
          Grey Structure Budget House
          <input
            type="number"
            name="grey_structure_budget_house_other_sq_ft"
            value={formData?.grey_structure_budget_house_other_sq_ft}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </label>
        <label>
          Basement Grey Good
          <input
            type="number"
            name="basement_grey_structure_good_sq_ft"
            value={formData?.basement_grey_structure_good_sq_ft}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </label>
        <label>
          Grey Structure Good House
          <input
            type="number"
            name="grey_structure_good_house_other_sq_ft"
            value={formData?.grey_structure_good_house_other_sq_ft}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </label>
        <label>
          Budget Finishes
          <input
            type="number"
            name="budget_finishes_sq_ft"
            value={formData?.budget_finishes_sq_ft}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </label>
        <label>
          A Quality Finishes
          <input
            type="number"
            name="a_quality_finishes_sq_ft"
            value={formData?.a_quality_finishes_sq_ft}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </label>
        <label className="col-span-2">
          Premium Quality Finishes
          <input
            type="number"
            name="premium_quality_finishes_sq_ft"
            value={formData?.premium_quality_finishes_sq_ft}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </label>
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border rounded text-gray-600 hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default TentativeCostForm;
